import React, { useState, Component } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { SearchInput } from '../../components/ui/Input';
import { useParams, useNavigate } from 'react-router-dom';
import { Activity, Clock, Eye, MousePointer, Share2, Download, TrendingUp, Calendar, Sliders, Monitor, Move, Zap, Grid, Maximize, Settings, Sun, Moon, Camera, EyeOff, Users } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// --- Shared Data ---
const projects = ['All Projects', 'The Riverside Collection', 'Coastal Living', 'Summit Ridge', 'Pioneer Square'];
// --- User Stats Data (formerly Telemetry) ---
const sessionData = [{
  date: 'Jan 1',
  sessions: 234,
  avgDuration: 18
}, {
  date: 'Jan 2',
  sessions: 289,
  avgDuration: 22
}, {
  date: 'Jan 3',
  sessions: 312,
  avgDuration: 20
}, {
  date: 'Jan 4',
  sessions: 267,
  avgDuration: 19
}, {
  date: 'Jan 5',
  sessions: 298,
  avgDuration: 21
}, {
  date: 'Jan 6',
  sessions: 245,
  avgDuration: 17
}, {
  date: 'Jan 7',
  sessions: 278,
  avgDuration: 23
}];
const eventData = [{
  event: 'Model Views',
  count: 3247,
  change: '+12%'
}, {
  event: 'Option Views',
  count: 8932,
  change: '+18%'
}, {
  event: 'Option Selections',
  count: 4521,
  change: '+8%'
}, {
  event: 'Share Actions',
  count: 892,
  change: '+15%'
}, {
  event: 'Export Actions',
  count: 456,
  change: '+22%'
}];
const recentSessions = [{
  id: 1,
  user: 'User-8823',
  builder: 'Excel Homes',
  project: 'The Oakwood',
  duration: '24 mins',
  events: 45,
  timestamp: '2 hours ago'
}, {
  id: 2,
  user: 'User-7732',
  builder: 'Schell Brothers',
  project: 'Coastal Living',
  duration: '18 mins',
  events: 32,
  timestamp: '3 hours ago'
}, {
  id: 3,
  user: 'User-5519',
  builder: 'Mattamy Homes',
  project: 'Summit Ridge',
  duration: '31 mins',
  events: 67,
  timestamp: '5 hours ago'
}, {
  id: 4,
  user: 'User-6621',
  builder: 'Excel Homes',
  project: 'Maple Ridge',
  duration: '15 mins',
  events: 28,
  timestamp: '1 day ago'
}];
function UserStatsView() {
  const [searchQuery, setSearchQuery] = useState('');
  const [timeRange, setTimeRange] = useState('7d');
  const filteredSessions = recentSessions.filter(session => session.user.toLowerCase().includes(searchQuery.toLowerCase()) || session.builder.toLowerCase().includes(searchQuery.toLowerCase()) || session.project.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-530">
      <div className="flex items-center justify-between" data-id="element-531">
        <div data-id="element-532">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-533">User Stats</h1>
          <p className="text-slate-500" data-id="element-534">
            Platform usage metrics and event tracking
          </p>
        </div>
        <div className="flex gap-3" data-id="element-535">
          <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-536">
            <option value="24h" data-id="element-537">Last 24 Hours</option>
            <option value="7d" data-id="element-538">Last 7 Days</option>
            <option value="30d" data-id="element-539">Last 30 Days</option>
            <option value="90d" data-id="element-540">Last 90 Days</option>
          </select>
          <Button variant="outline" data-id="element-541">Export Report</Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-542">
        <Card data-id="element-543">
          <CardContent className="flex items-center p-6" data-id="element-544">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-545">
              <Activity className="h-6 w-6 text-primary-600" data-id="element-546" />
            </div>
            <div className="ml-4" data-id="element-547">
              <p className="text-sm font-medium text-slate-500" data-id="element-548">
                Total Sessions
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-549">1,923</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-550">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-551" />
                <span className="font-medium" data-id="element-552">+12%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-553">
          <CardContent className="flex items-center p-6" data-id="element-554">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-555">
              <Clock className="h-6 w-6 text-slate-600" data-id="element-556" />
            </div>
            <div className="ml-4" data-id="element-557">
              <p className="text-sm font-medium text-slate-500" data-id="element-558">
                Avg Session Time
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-559">20m</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-560">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-561" />
                <span className="font-medium" data-id="element-562">+8%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-563">
          <CardContent className="flex items-center p-6" data-id="element-564">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-565">
              <Eye className="h-6 w-6 text-slate-600" data-id="element-566" />
            </div>
            <div className="ml-4" data-id="element-567">
              <p className="text-sm font-medium text-slate-500" data-id="element-568">Total Events</p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-569">18.0k</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-570">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-571" />
                <span className="font-medium" data-id="element-572">+15%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-573">
          <CardContent className="flex items-center p-6" data-id="element-574">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-575">
              <MousePointer className="h-6 w-6 text-slate-600" data-id="element-576" />
            </div>
            <div className="ml-4" data-id="element-577">
              <p className="text-sm font-medium text-slate-500" data-id="element-578">
                Avg Events/Session
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-579">9.4</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-580">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-581" />
                <span className="font-medium" data-id="element-582">+3%</span>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-583">
        <Card data-id="element-584">
          <CardHeader data-id="element-585">
            <CardTitle data-id="element-586">Session Activity</CardTitle>
          </CardHeader>
          <CardContent data-id="element-587">
            <div className="h-[300px] w-full" data-id="element-588">
              <ResponsiveContainer width="100%" height="100%" data-id="element-589">
                <LineChart data={sessionData} data-id="element-590">
                  <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-591" />
                  <XAxis dataKey="date" tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-592" />
                  <YAxis tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-593" />
                  <Tooltip contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                }} data-id="element-594" />
                  <Line type="monotone" dataKey="sessions" stroke="#06b6d4" strokeWidth={2} dot={{
                  fill: '#06b6d4'
                }} data-id="element-595" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-596">
          <CardHeader data-id="element-597">
            <CardTitle data-id="element-598">Event Distribution</CardTitle>
          </CardHeader>
          <CardContent data-id="element-599">
            <div className="space-y-4" data-id="element-600">
              {eventData.map(item => <div key={item.event} className="flex items-center justify-between" data-id="element-601">
                  <div className="flex items-center gap-3" data-id="element-602">
                    <div className="h-10 w-10 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-603">
                      {item.event === 'Model Views' && <Eye className="h-5 w-5 text-slate-600" data-id="element-604" />}
                      {item.event === 'Option Views' && <Eye className="h-5 w-5 text-slate-600" data-id="element-605" />}
                      {item.event === 'Option Selections' && <MousePointer className="h-5 w-5 text-slate-600" data-id="element-606" />}
                      {item.event === 'Share Actions' && <Share2 className="h-5 w-5 text-slate-600" data-id="element-607" />}
                      {item.event === 'Export Actions' && <Download className="h-5 w-5 text-slate-600" data-id="element-608" />}
                    </div>
                    <div data-id="element-609">
                      <p className="text-sm font-medium text-slate-900" data-id="element-610">
                        {item.event}
                      </p>
                      <p className="text-xs text-green-600" data-id="element-611">
                        {item.change} vs last period
                      </p>
                    </div>
                  </div>
                  <span className="text-2xl font-bold text-slate-900" data-id="element-612">
                    {item.count.toLocaleString()}
                  </span>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Recent Sessions */}
      <Card noPadding data-id="element-613">
        <CardHeader className="border-b border-slate-200 bg-slate-50" data-id="element-614">
          <div className="flex items-center justify-between" data-id="element-615">
            <CardTitle data-id="element-616">Recent Sessions</CardTitle>
            <SearchInput className="max-w-xs bg-white" placeholder="Search sessions..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-617" />
          </div>
        </CardHeader>

        <div className="overflow-x-auto" data-id="element-618">
          <table className="w-full text-left text-sm" data-id="element-619">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-620">
              <tr data-id="element-621">
                <th className="px-6 py-4" data-id="element-622">User ID</th>
                <th className="px-6 py-4" data-id="element-623">Builder</th>
                <th className="px-6 py-4" data-id="element-624">Project</th>
                <th className="px-6 py-4" data-id="element-625">Duration</th>
                <th className="px-6 py-4" data-id="element-626">Events</th>
                <th className="px-6 py-4" data-id="element-627">Timestamp</th>
                <th className="px-6 py-4 text-right" data-id="element-628">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-629">
              {filteredSessions.length === 0 ? <tr data-id="element-630">
                  <td colSpan={7} className="px-6 py-12 text-center text-slate-500" data-id="element-631">
                    No sessions found matching "{searchQuery}"
                  </td>
                </tr> : filteredSessions.map(session => <tr key={session.id} className="hover:bg-slate-50 transition-colors" data-id="element-632">
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-633">
                      {session.user}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-634">
                      {session.builder}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-635">
                      {session.project}
                    </td>
                    <td className="px-6 py-4" data-id="element-636">
                      <div className="flex items-center gap-1 text-slate-600" data-id="element-637">
                        <Clock className="h-4 w-4 text-slate-400" data-id="element-638" />
                        {session.duration}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-639">
                      <Badge variant="neutral" data-id="element-640">{session.events} events</Badge>
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-641">
                      <div className="flex items-center gap-1" data-id="element-642">
                        <Calendar className="h-3 w-3 text-slate-400" data-id="element-643" />
                        {session.timestamp}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-644">
                      <Button variant="ghost" size="sm" data-id="element-645">
                        View Details
                      </Button>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}
// --- Listing & Controls Data ---
const graphicsData = [{
  name: 'Low',
  value: 142,
  percentage: 3,
  color: '#94a3b8'
}, {
  name: 'Medium',
  value: 589,
  percentage: 12,
  color: '#64748b'
}, {
  name: 'High',
  value: 2415,
  percentage: 50,
  color: '#06b6d4'
}, {
  name: 'Epic',
  value: 1204,
  percentage: 25,
  color: '#0891b2'
}, {
  name: 'Cinematic',
  value: 482,
  percentage: 10,
  color: '#155e75'
}];
const listingModeData = [{
  name: 'Grid View',
  value: 3186,
  color: '#06b6d4'
}, {
  name: 'Horizontal',
  value: 1646,
  color: '#94a3b8'
}];
const resolutionData = [{
  range: '0-20%',
  count: 98
}, {
  range: '20-40%',
  count: 245
}, {
  range: '40-60%',
  count: 612
}, {
  range: '60-80%',
  count: 1890
}, {
  range: '80-100%',
  count: 1987
}];
const moveSpeedData = [{
  range: '0-20%',
  count: 312
}, {
  range: '20-40%',
  count: 1245
}, {
  range: '40-60%',
  count: 1890
}, {
  range: '60-80%',
  count: 987
}, {
  range: '80-100%',
  count: 398
}];
const lookSpeedData = [{
  range: '0-20%',
  count: 198
}, {
  range: '20-40%',
  count: 876
}, {
  range: '40-60%',
  count: 2102
}, {
  range: '60-80%',
  count: 1234
}, {
  range: '80-100%',
  count: 422
}];
const booleanControlsData = [{
  name: 'Invert Vertical Axis',
  enabled: 870,
  disabled: 3962,
  enabledPct: 18
}, {
  name: 'Teleport to Option',
  enabled: 1643,
  disabled: 3189,
  enabledPct: 34
}];
function ListingView() {
  const [timeRange, setTimeRange] = useState('30d');
  const [selectedProject, setSelectedProject] = useState('All Projects');
  return <div className="space-y-8" data-id="element-646">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-647">
        <div data-id="element-648">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-649">
            Listing Analytics
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-650">
            Graphics quality, resolution and display mode preferences
          </p>
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-651">
          <select value={selectedProject} onChange={e => setSelectedProject(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-652">
            {projects.map(p => <option key={p} value={p} data-id="element-653">
                {p}
              </option>)}
          </select>
          <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-654">
            <option value="24h" data-id="element-655">Last 24 Hours</option>
            <option value="7d" data-id="element-656">Last 7 Days</option>
            <option value="30d" data-id="element-657">Last 30 Days</option>
            <option value="90d" data-id="element-658">Last 90 Days</option>
          </select>
          <Button variant="outline" data-id="element-659">Export Report</Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-660">
        <Card data-id="element-661">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-662">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-663">
              <Monitor className="h-6 w-6 text-primary-600" data-id="element-664" />
            </div>
            <div data-id="element-665">
              <p className="text-sm font-medium text-slate-500" data-id="element-666">
                Sessions Tracked
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-667">4,832</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-668">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-669" />
                <span className="font-medium" data-id="element-670">+12%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-671">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-672">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-673">
              <Monitor className="h-6 w-6 text-slate-600" data-id="element-674" />
            </div>
            <div data-id="element-675">
              <p className="text-sm font-medium text-slate-500" data-id="element-676">Top Graphics</p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-677">High</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-678">50% of users</p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-679">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-680">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-681">
              <Maximize className="h-6 w-6 text-slate-600" data-id="element-682" />
            </div>
            <div data-id="element-683">
              <p className="text-sm font-medium text-slate-500" data-id="element-684">
                Avg Resolution
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-685">78%</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-686">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-687" />
                <span className="font-medium" data-id="element-688">+5%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-689">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-690">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-691">
              <Grid className="h-6 w-6 text-slate-600" data-id="element-692" />
            </div>
            <div data-id="element-693">
              <p className="text-sm font-medium text-slate-500" data-id="element-694">
                Preferred Layout
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-695">Grid</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-696">66% of users</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Display Settings Section */}
      <div className="space-y-4" data-id="element-697">
        <div className="flex items-center gap-2 pb-2 border-b border-slate-200" data-id="element-698">
          <Monitor className="h-5 w-5 text-slate-500" data-id="element-699" />
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-700">
            Display Settings
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-701">
          {/* Graphics Quality */}
          <Card className="lg:col-span-2" data-id="element-702">
            <CardHeader data-id="element-703">
              <CardTitle data-id="element-704">Graphics Quality Distribution</CardTitle>
            </CardHeader>
            <CardContent data-id="element-705">
              <div className="h-[300px] w-full" data-id="element-706">
                <ResponsiveContainer width="100%" height="100%" data-id="element-707">
                  <BarChart data={graphicsData} layout="vertical" margin={{
                  top: 5,
                  right: 30,
                  left: 40,
                  bottom: 5
                }} data-id="element-708">
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e2e8f0" data-id="element-709" />
                    <XAxis type="number" hide data-id="element-710" />
                    <YAxis dataKey="name" type="category" width={80} tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} axisLine={false} tickLine={false} data-id="element-711" />
                    <Tooltip cursor={{
                    fill: '#f1f5f9'
                  }} contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-712" />
                    <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={32} name="Users" data-id="element-713">
                      {graphicsData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-714" />)}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          {/* Listing Mode */}
          <Card data-id="element-715">
            <CardHeader data-id="element-716">
              <CardTitle data-id="element-717">Listing Mode Preference</CardTitle>
            </CardHeader>
            <CardContent data-id="element-718">
              <div className="h-[220px] w-full relative" data-id="element-719">
                <ResponsiveContainer width="100%" height="100%" data-id="element-720">
                  <PieChart data-id="element-721">
                    <Pie data={listingModeData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-722">
                      {listingModeData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-723" />)}
                    </Pie>
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-724" />
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-725">
                  <Grid className="h-8 w-8 text-slate-400" data-id="element-726" />
                </div>
              </div>
              <div className="mt-4 space-y-3" data-id="element-727">
                {listingModeData.map(item => <div key={item.name} className="flex items-center justify-between" data-id="element-728">
                    <div className="flex items-center gap-2" data-id="element-729">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-730" />
                      <span className="text-sm text-slate-600" data-id="element-731">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-sm font-medium text-slate-900" data-id="element-732">
                      {(item.value / 4832 * 100).toFixed(0)}%
                    </span>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Resolution Distribution */}
          <Card className="lg:col-span-3" data-id="element-733">
            <CardHeader data-id="element-734">
              <div className="flex items-center justify-between" data-id="element-735">
                <CardTitle data-id="element-736">Resolution Scale Distribution</CardTitle>
                <Badge variant="neutral" data-id="element-737">Avg: 78%</Badge>
              </div>
            </CardHeader>
            <CardContent data-id="element-738">
              <div className="h-[250px] w-full" data-id="element-739">
                <ResponsiveContainer width="100%" height="100%" data-id="element-740">
                  <BarChart data={resolutionData} data-id="element-741">
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-742" />
                    <XAxis dataKey="range" tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-743" />
                    <YAxis tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-744" />
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-745" />
                    <Bar dataKey="count" fill="#06b6d4" radius={[4, 4, 0, 0]} name="Users" data-id="element-746" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>;
}
function ControlsView() {
  const [timeRange, setTimeRange] = useState('30d');
  const [selectedProject, setSelectedProject] = useState('All Projects');
  return <div className="space-y-8" data-id="element-747">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-748">
        <div data-id="element-749">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-750">
            Controls Analytics
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-751">
            Movement and camera preferences across all sessions
          </p>
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-752">
          <select value={selectedProject} onChange={e => setSelectedProject(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-753">
            {projects.map(p => <option key={p} value={p} data-id="element-754">
                {p}
              </option>)}
          </select>
          <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-755">
            <option value="24h" data-id="element-756">Last 24 Hours</option>
            <option value="7d" data-id="element-757">Last 7 Days</option>
            <option value="30d" data-id="element-758">Last 30 Days</option>
            <option value="90d" data-id="element-759">Last 90 Days</option>
          </select>
          <Button variant="outline" data-id="element-760">Export Report</Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-761">
        <Card data-id="element-762">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-763">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-764">
              <Sliders className="h-6 w-6 text-primary-600" data-id="element-765" />
            </div>
            <div data-id="element-766">
              <p className="text-sm font-medium text-slate-500" data-id="element-767">
                Sessions Tracked
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-768">4,832</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-769">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-770" />
                <span className="font-medium" data-id="element-771">+12%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-772">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-773">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-774">
              <Sliders className="h-6 w-6 text-slate-600" data-id="element-775" />
            </div>
            <div data-id="element-776">
              <p className="text-sm font-medium text-slate-500" data-id="element-777">
                Avg Move Speed
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-778">45%</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-779">Default: 50%</p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-780">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-781">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-782">
              <Eye className="h-6 w-6 text-slate-600" data-id="element-783" />
            </div>
            <div data-id="element-784">
              <p className="text-sm font-medium text-slate-500" data-id="element-785">
                Avg Look Speed
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-786">52%</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-787">Default: 50%</p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-788">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-789">
            <div className="p-3 bg-emerald-50 rounded-lg" data-id="element-790">
              <Zap className="h-6 w-6 text-emerald-600" data-id="element-791" />
            </div>
            <div data-id="element-792">
              <p className="text-sm font-medium text-slate-500" data-id="element-793">
                Teleport Usage
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-794">34%</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-795">Enabled rate</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Movement & Camera Controls Section */}
      <div className="space-y-4" data-id="element-796">
        <div className="flex items-center gap-2 pb-2 border-b border-slate-200" data-id="element-797">
          <Move className="h-5 w-5 text-slate-500" data-id="element-798" />
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-799">
            Movement & Camera Controls
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-800">
          {/* Move Speed */}
          <Card data-id="element-801">
            <CardHeader data-id="element-802">
              <div className="flex items-center justify-between" data-id="element-803">
                <CardTitle data-id="element-804">Move Speed Settings</CardTitle>
                <Badge variant="neutral" data-id="element-805">Avg: 45%</Badge>
              </div>
            </CardHeader>
            <CardContent data-id="element-806">
              <div className="h-[250px] w-full" data-id="element-807">
                <ResponsiveContainer width="100%" height="100%" data-id="element-808">
                  <BarChart data={moveSpeedData} data-id="element-809">
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-810" />
                    <XAxis dataKey="range" tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-811" />
                    <YAxis tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-812" />
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-813" />
                    <Bar dataKey="count" fill="#84cc16" radius={[4, 4, 0, 0]} name="Users" data-id="element-814" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          {/* Look Speed */}
          <Card data-id="element-815">
            <CardHeader data-id="element-816">
              <div className="flex items-center justify-between" data-id="element-817">
                <CardTitle data-id="element-818">Look Speed Settings</CardTitle>
                <Badge variant="neutral" data-id="element-819">Avg: 52%</Badge>
              </div>
            </CardHeader>
            <CardContent data-id="element-820">
              <div className="h-[250px] w-full" data-id="element-821">
                <ResponsiveContainer width="100%" height="100%" data-id="element-822">
                  <BarChart data={lookSpeedData} data-id="element-823">
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-824" />
                    <XAxis dataKey="range" tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-825" />
                    <YAxis tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-826" />
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-827" />
                    <Bar dataKey="count" fill="#84cc16" radius={[4, 4, 0, 0]} name="Users" data-id="element-828" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          {/* Boolean Controls */}
          <Card className="lg:col-span-2" data-id="element-829">
            <CardHeader data-id="element-830">
              <CardTitle data-id="element-831">Toggle Preferences</CardTitle>
            </CardHeader>
            <CardContent data-id="element-832">
              <div className="space-y-8" data-id="element-833">
                {booleanControlsData.map(control => <div key={control.name} className="space-y-2" data-id="element-834">
                    <div className="flex justify-between items-center text-sm" data-id="element-835">
                      <span className="font-medium text-slate-900" data-id="element-836">
                        {control.name}
                      </span>
                      <span className="text-slate-500" data-id="element-837">
                        {control.enabledPct}% Enabled
                      </span>
                    </div>
                    <div className="relative h-8 w-full bg-slate-100 rounded-full overflow-hidden flex" data-id="element-838">
                      <div className="h-full bg-emerald-500 flex items-center justify-center text-xs font-medium text-white transition-all duration-500" style={{
                    width: `${control.enabledPct}%`
                  }} data-id="element-839">
                        {control.enabledPct >= 10 && 'Enabled'}
                      </div>
                      <div className="flex-1 flex items-center justify-center text-xs font-medium text-slate-500" data-id="element-840">
                        Disabled
                      </div>
                    </div>
                    <div className="flex justify-between text-xs text-slate-400 px-1" data-id="element-841">
                      <span data-id="element-842">{control.enabled.toLocaleString()} users</span>
                      <span data-id="element-843">{control.disabled.toLocaleString()} users</span>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>;
}
// --- Settings Data & Components ---
const heightData = [{
  range: '90-110cm',
  count: 120
}, {
  range: '110-130cm',
  count: 450
}, {
  range: '130-150cm',
  count: 980
}, {
  range: '150-170cm',
  count: 2100
}, {
  range: '170-190cm',
  count: 1182
}];
const zoomData = [{
  range: '80-88',
  count: 320
}, {
  range: '88-96',
  count: 890
}, {
  range: '96-104',
  count: 2450
}, {
  range: '104-112',
  count: 920
}, {
  range: '112-120',
  count: 252
}];
const daytimeData = [{
  name: 'Morning',
  value: 1245,
  color: '#f59e0b'
}, {
  name: 'Noon',
  value: 2890,
  color: '#0ea5e9'
}, {
  name: 'Evening',
  value: 697,
  color: '#6366f1'
}];
const modeData = [{
  name: 'Dark',
  value: 1876,
  color: '#1e293b'
}, {
  name: 'Light',
  value: 2956,
  color: '#cbd5e1'
}];
const visibilityData = [{
  name: 'Hide Doors',
  enabled: 1423,
  disabled: 3409,
  enabledPct: 29
}, {
  name: 'Hide Dressing',
  enabled: 876,
  disabled: 3956,
  enabledPct: 18
}, {
  name: 'Hide Vegetation',
  enabled: 534,
  disabled: 4298,
  enabledPct: 11
}];
function SettingsAnalyticsView() {
  const [timeRange, setTimeRange] = useState('30d');
  const [selectedProject, setSelectedProject] = useState('All Projects');
  return <div className="space-y-8" data-id="element-844">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-845">
        <div data-id="element-846">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-847">
            Settings Analytics
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-848">
            Environment and display preferences across sessions
          </p>
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-849">
          <select value={selectedProject} onChange={e => setSelectedProject(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-850">
            {projects.map(p => <option key={p} value={p} data-id="element-851">
                {p}
              </option>)}
          </select>
          <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-852">
            <option value="24h" data-id="element-853">Last 24 Hours</option>
            <option value="7d" data-id="element-854">Last 7 Days</option>
            <option value="30d" data-id="element-855">Last 30 Days</option>
            <option value="90d" data-id="element-856">Last 90 Days</option>
          </select>
          <Button variant="outline" data-id="element-857">Export Report</Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-858">
        <Card data-id="element-859">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-860">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-861">
              <Settings className="h-6 w-6 text-primary-600" data-id="element-862" />
            </div>
            <div data-id="element-863">
              <p className="text-sm font-medium text-slate-500" data-id="element-864">
                Sessions Tracked
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-865">4,832</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-866">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-867" />
                <span className="font-medium" data-id="element-868">+12%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-869">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-870">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-871">
              <Move className="h-6 w-6 text-slate-600" data-id="element-872" />
            </div>
            <div data-id="element-873">
              <p className="text-sm font-medium text-slate-500" data-id="element-874">
                Most Used Height
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-875">162cm</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-876">Avg user height</p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-877">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-878">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-879">
              <Sun className="h-6 w-6 text-slate-600" data-id="element-880" />
            </div>
            <div data-id="element-881">
              <p className="text-sm font-medium text-slate-500" data-id="element-882">
                Preferred Daytime
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-883">Noon</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-884">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-885" />
                <span className="font-medium" data-id="element-886">60%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-887">
          <CardContent className="p-6 flex items-center gap-4" data-id="element-888">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-889">
              <Moon className="h-6 w-6 text-slate-600" data-id="element-890" />
            </div>
            <div data-id="element-891">
              <p className="text-sm font-medium text-slate-500" data-id="element-892">
                Light Mode Usage
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-893">61%</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-894">vs 39% Dark</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Camera Settings Section */}
      <div className="space-y-4" data-id="element-895">
        <div className="flex items-center gap-2 pb-2 border-b border-slate-200" data-id="element-896">
          <Camera className="h-5 w-5 text-slate-500" data-id="element-897" />
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-898">
            Camera Settings
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-899">
          {/* Height Histogram */}
          <Card data-id="element-900">
            <CardHeader data-id="element-901">
              <div className="flex items-center justify-between" data-id="element-902">
                <CardTitle data-id="element-903">Camera Height Distribution</CardTitle>
                <Badge variant="neutral" data-id="element-904">Avg: 162cm</Badge>
              </div>
            </CardHeader>
            <CardContent data-id="element-905">
              <div className="h-[250px] w-full" data-id="element-906">
                <ResponsiveContainer width="100%" height="100%" data-id="element-907">
                  <BarChart data={heightData} data-id="element-908">
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-909" />
                    <XAxis dataKey="range" tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-910" />
                    <YAxis tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-911" />
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-912" />
                    <Bar dataKey="count" fill="#06b6d4" radius={[4, 4, 0, 0]} name="Users" data-id="element-913" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          {/* Zoom Histogram */}
          <Card data-id="element-914">
            <CardHeader data-id="element-915">
              <div className="flex items-center justify-between" data-id="element-916">
                <CardTitle data-id="element-917">Camera Zoom Distribution</CardTitle>
                <Badge variant="neutral" data-id="element-918">Avg: 100</Badge>
              </div>
            </CardHeader>
            <CardContent data-id="element-919">
              <div className="h-[250px] w-full" data-id="element-920">
                <ResponsiveContainer width="100%" height="100%" data-id="element-921">
                  <BarChart data={zoomData} data-id="element-922">
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-923" />
                    <XAxis dataKey="range" tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-924" />
                    <YAxis tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} data-id="element-925" />
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-926" />
                    <Bar dataKey="count" fill="#84cc16" radius={[4, 4, 0, 0]} name="Users" data-id="element-927" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Environment Preferences Section */}
      <div className="space-y-4" data-id="element-928">
        <div className="flex items-center gap-2 pb-2 border-b border-slate-200" data-id="element-929">
          <Sun className="h-5 w-5 text-slate-500" data-id="element-930" />
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-931">
            Environment Preferences
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-932">
          {/* Daytime Pie Chart */}
          <Card data-id="element-933">
            <CardHeader data-id="element-934">
              <CardTitle data-id="element-935">Time of Day Preference</CardTitle>
            </CardHeader>
            <CardContent data-id="element-936">
              <div className="h-[220px] w-full relative" data-id="element-937">
                <ResponsiveContainer width="100%" height="100%" data-id="element-938">
                  <PieChart data-id="element-939">
                    <Pie data={daytimeData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-940">
                      {daytimeData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-941" />)}
                    </Pie>
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-942" />
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-943">
                  <Sun className="h-8 w-8 text-slate-400" data-id="element-944" />
                </div>
              </div>
              <div className="mt-4 space-y-3" data-id="element-945">
                {daytimeData.map(item => <div key={item.name} className="flex items-center justify-between" data-id="element-946">
                    <div className="flex items-center gap-2" data-id="element-947">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-948" />
                      <span className="text-sm text-slate-600" data-id="element-949">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-sm font-medium text-slate-900" data-id="element-950">
                      {(item.value / 4832 * 100).toFixed(0)}%
                    </span>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Mode Pie Chart */}
          <Card data-id="element-951">
            <CardHeader data-id="element-952">
              <CardTitle data-id="element-953">Theme Mode Preference</CardTitle>
            </CardHeader>
            <CardContent data-id="element-954">
              <div className="h-[220px] w-full relative" data-id="element-955">
                <ResponsiveContainer width="100%" height="100%" data-id="element-956">
                  <PieChart data-id="element-957">
                    <Pie data={modeData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-958">
                      {modeData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-959" />)}
                    </Pie>
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} data-id="element-960" />
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-961">
                  <Moon className="h-8 w-8 text-slate-400" data-id="element-962" />
                </div>
              </div>
              <div className="mt-4 space-y-3" data-id="element-963">
                {modeData.map(item => <div key={item.name} className="flex items-center justify-between" data-id="element-964">
                    <div className="flex items-center gap-2" data-id="element-965">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-966" />
                      <span className="text-sm text-slate-600" data-id="element-967">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-sm font-medium text-slate-900" data-id="element-968">
                      {(item.value / 4832 * 100).toFixed(0)}%
                    </span>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Visibility Toggles Section */}
      <div className="space-y-4" data-id="element-969">
        <div className="flex items-center gap-2 pb-2 border-b border-slate-200" data-id="element-970">
          <EyeOff className="h-5 w-5 text-slate-500" data-id="element-971" />
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-972">
            Visibility Toggles
          </h2>
        </div>

        <Card data-id="element-973">
          <CardHeader data-id="element-974">
            <CardTitle data-id="element-975">Feature Visibility Settings</CardTitle>
          </CardHeader>
          <CardContent data-id="element-976">
            <div className="space-y-8" data-id="element-977">
              {visibilityData.map(control => <div key={control.name} className="space-y-2" data-id="element-978">
                  <div className="flex justify-between items-center text-sm" data-id="element-979">
                    <span className="font-medium text-slate-900" data-id="element-980">
                      {control.name}
                    </span>
                    <span className="text-slate-500" data-id="element-981">
                      {control.enabledPct}% Enabled
                    </span>
                  </div>
                  <div className="relative h-8 w-full bg-slate-100 rounded-full overflow-hidden flex" data-id="element-982">
                    <div className="h-full bg-emerald-500 flex items-center justify-center text-xs font-medium text-white transition-all duration-500" style={{
                  width: `${control.enabledPct}%`
                }} data-id="element-983">
                      {control.enabledPct >= 10 && 'Enabled'}
                    </div>
                    <div className="flex-1 flex items-center justify-center text-xs font-medium text-slate-500" data-id="element-984">
                      Disabled
                    </div>
                  </div>
                  <div className="flex justify-between text-xs text-slate-400 px-1" data-id="element-985">
                    <span data-id="element-986">{control.enabled.toLocaleString()} users</span>
                    <span data-id="element-987">{control.disabled.toLocaleString()} users</span>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}
// --- Main Page Component ---
type AnalyticsSection = 'listing' | 'controls' | 'settings' | 'user-stats';
const validSections: AnalyticsSection[] = ['user-stats', 'listing', 'controls', 'settings'];
export function AdminAnalyticsPage() {
  const {
    tab
  } = useParams<{
    tab: string;
  }>();
  const navigate = useNavigate();
  const activeSection: AnalyticsSection = validSections.includes(tab as AnalyticsSection) ? tab as AnalyticsSection : 'user-stats';
  const sections = [{
    id: 'user-stats' as const,
    label: 'User Stats',
    icon: Users,
    description: 'Session and event tracking'
  }, {
    id: 'listing' as const,
    label: 'Listing',
    icon: Monitor,
    description: 'Graphics, resolution & display'
  }, {
    id: 'controls' as const,
    label: 'Controls',
    icon: Sliders,
    description: 'Movement & camera controls'
  }, {
    id: 'settings' as const,
    label: 'Settings',
    icon: Settings,
    description: 'Environment and display settings'
  }];
  return <div className="flex gap-6 max-w-7xl mx-auto h-[calc(100vh-8rem)]" data-id="element-988">
      {/* Sidebar Navigation */}
      <div className="w-64 flex-shrink-0" data-id="element-989">
        <Card className="h-full overflow-y-auto" noPadding data-id="element-990">
          <div className="p-4 border-b border-slate-200" data-id="element-991">
            <h2 className="font-semibold text-slate-900" data-id="element-992">Analytics</h2>
            <p className="text-xs text-slate-500 mt-1" data-id="element-993">
              Platform insights & data
            </p>
          </div>
          <nav className="p-2 space-y-1" data-id="element-994">
            {sections.map(section => {
            const Icon = section.icon;
            return <button key={section.id} onClick={() => navigate(`/admin/analytics/${section.id}`)} className={`
                    w-full flex items-center gap-3 px-3 py-3 rounded-md text-sm transition-all
                    ${activeSection === section.id ? 'bg-primary-50 text-primary-700 font-medium shadow-sm' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}
                  `} data-id="element-995">
                  <Icon className="h-4 w-4 flex-shrink-0" data-id="element-996" />
                  <div className="text-left" data-id="element-997">
                    <div className="font-medium" data-id="element-998">{section.label}</div>
                    <div className={`text-xs mt-0.5 ${activeSection === section.id ? 'text-primary-500' : 'text-slate-400'}`} data-id="element-999">
                      {section.description}
                    </div>
                  </div>
                </button>;
          })}
          </nav>
        </Card>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto pr-2" data-id="element-1000">
        {activeSection === 'listing' && <ListingView data-id="element-1001" />}
        {activeSection === 'controls' && <ControlsView data-id="element-1002" />}
        {activeSection === 'settings' && <SettingsAnalyticsView data-id="element-1003" />}
        {activeSection === 'user-stats' && <UserStatsView data-id="element-1004" />}
      </div>
    </div>;
}